import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useOrpcTanstackQueryUtils } from '../orpc'

export function useEquipmentGetByAircraft(
  aircraftId: string,
  options?: { enabled?: boolean }
) {
  const orpc = useOrpcTanstackQueryUtils()
  return useQuery(
    orpc.equipment.getByAircraft.queryOptions({
      input: { aircraftId },
      enabled: !!aircraftId && (options?.enabled ?? true),
    })
  )
}

function useEquipmentInvalidate(aircraftId: string) {
  const orpc = useOrpcTanstackQueryUtils()
  const queryClient = useQueryClient()
  return () => {
    queryClient.invalidateQueries({
      queryKey: orpc.equipment.getByAircraft.key({ input: { aircraftId } }),
    })
  }
}

export function useEquipmentCreate(aircraftId: string) {
  const orpc = useOrpcTanstackQueryUtils()
  const invalidate = useEquipmentInvalidate(aircraftId)
  return useMutation(
    orpc.equipment.create.mutationOptions({
      onSuccess: invalidate,
    })
  )
}

export function useEquipmentUpdate(aircraftId: string) {
  const orpc = useOrpcTanstackQueryUtils()
  const invalidate = useEquipmentInvalidate(aircraftId)
  return useMutation(
    orpc.equipment.update.mutationOptions({
      onSuccess: invalidate,
    })
  )
}

export function useEquipmentDelete(aircraftId: string) {
  const orpc = useOrpcTanstackQueryUtils()
  const invalidate = useEquipmentInvalidate(aircraftId)
  return useMutation(
    orpc.equipment.delete.mutationOptions({
      onSuccess: invalidate,
    })
  )
}
